/*
 *
 * Footer
 *
 */

import React from "react";
import { connect } from "react-redux";
import { Icons } from "components";
import { DateTime } from "luxon";
import strings from "utils/strings";
import "./styles.scss";
import { localhostType, psychologistsSubDomains } from "screens/App/routes";
export class Footer extends React.Component<any, any> {
	render() {
		const hostname = window.location.hostname?.split(".")?.[0];
		const { user } = this.props;
		
		let footerString = strings.generic.supportPlan;
		/* @ts-ignore */
		if ((hostname === "localhost" && localhostType === "psychologists") || psychologistsSubDomains.includes(hostname)) {
			footerString = strings.generic.supportPlanPsyc;
		} else if (user?.isHR) footerString = strings.generic.supportPlanHr;

		return (
			<footer>
				<div className="FooterBanner">
					<p>{footerString}</p>
				</div>
				<div className="FooterSection">
					<div className="FooterAppButtons">
						<a href="https://apps.apple.com/app/team24/id1614817254" target="_blank" rel="noopener noreferrer">
							<Icons.AppStore />
						</a>
						<a href="https://play.google.com/store/apps/details?id=com.team24.app" target="_blank" rel="noopener noreferrer">
							<Icons.GooglePlay />
						</a>
					</div>
					<div className="FooterCopyright">
						<span>Copyright &copy; {DateTime.utc().year} - Team24</span>
					</div>
					<div className="FooterSocialLinks">
						<a href="https://www.facebook.com/MyTeam24EAP" target="_blank" rel="noopener noreferrer">
							<Icons.Facebook />
						</a>
						<a href="https://www.instagram.com/team24eap/" target="_blank" rel="noopener noreferrer">
							<Icons.Instagram />
						</a>
						<a href="https://www.linkedin.com/company/team24eap/" target="_blank" rel="noopener noreferrer">
							<Icons.LinkedIn />
						</a>
					</div>
				</div>
			</footer>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	user: state.user,
});

export default connect(mapStateToProps)(Footer);
